import '../../../App.css';

import DestaquesCards from './destaquesCards';

const Destaques = () => {
    return (
        // < !--Blog Start-- >
        <div className="container-fluid blog py-5 bg-gray-light">
            <div className="container py-5">
                <div className="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="sub-style">
                        <h4 className="sub-title px-3 mb-0">Treinamento</h4>
                    </div>
                    <h1 className="display-3 mb-4">Protocolos, Diretrizes e Documentações</h1>
                    <p className="mb-0">Referências essenciais para a prática segura, ética e compassiva na UTI Neonatal.</p>
                </div>
                <div>
                    <DestaquesCards />
                </div>
            </div>
            {/* <!--Blog End-- > */}
        </div>

    )
};

export default Destaques;